import React from "react";
import ExpertAvailabilitySetup from "./ExpertAvailabilitySetup";


const ExpertExaminationAvailabilitySetup: React.FunctionComponent = () => {
  return (
    <ExpertAvailabilitySetup
      title="expertAvailability.header"
      availabilityType="examination"
    />
  );
};

export default ExpertExaminationAvailabilitySetup;
